import { render, staticRenderFns } from "./BookingUiV2.vue?vue&type=template&id=3189c24a&scoped=true"
import script from "./BookingUiV2.vue?vue&type=script&lang=js"
export * from "./BookingUiV2.vue?vue&type=script&lang=js"
import style0 from "./BookingUiV2.vue?vue&type=style&index=0&id=3189c24a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3189c24a",
  null
  
)

export default component.exports